import { PRIMARY_ERROR_LIGHT } from 'src/global/theme/colors';
import { makeStyles } from 'tss-react/mui';

export const styles = makeStyles()(() => {
  return {
    operationError: {
      backgroundColor: PRIMARY_ERROR_LIGHT,
      borderRadius: '10px',
      padding: '12px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      verticalAlign: 'center'
    },
    divider: {
      marginTop: '8px',
      marginBottom: '8px'
    }
  };
});
